<template>
  <v-container>
    <v-row>
      <v-col col="12" class="pa-0">
        <div>
          <TypeFactory
            :node="node"
            :editMode="editMode"
            :editIndex="0"
            :selectedRecord="selectedRecord"
            :singleEditModeid="''"
            :isRoot="isRoot"
            :createMode="false"
            class="mt-3"
          />
        </div>
      </v-col>
    </v-row>
    <!-- <span v-if="editMode">
      <v-row class="pl-2">
        <v-col col class="mt-3 pb-0 d-flex">
          <v-col class="pb-0">
            <TypeFactory
              :node="node"
              :editMode="editMode"
              :editIndex="selectedIndex"
              :selectedRecord="selectedRecord"
              :isRoot="isRoot"
              :createMode="false"
              class="mt-3"
              v-on:resetform="resetForm()"
            />
          </v-col>
        </v-col>
      </v-row>
    </span> -->
  </v-container>
</template>

<script>
import TypeFactory from "../TypeFactory";
export default {
  components: {
    TypeFactory
  },
  props: {
    node: Object,
    editMode: Boolean,
    selectedRecord: Object,
    isRoot: Boolean
  }
};
</script>

<style></style>
